// AUTO-GENERATO (scan dei template) — registra SOLO le icone usate
// nell'app invece dell'intero pacchetto @ant-design (~790 icone, ~3MB nel
// bundle iniziale). Per ogni nome usato sono incluse tutte le varianti di
// tema esistenti (Outline/Fill/TwoTone) per coprire i binding dinamici di
// nzTheme. Se aggiungi un'icona nuova nei template, aggiungila anche qui.
import { IconDefinition } from "@ant-design/icons-angular";
import {
	AndroidOutline,
	AndroidFill,
	ApartmentOutline,
	AppleOutline,
	AppleFill,
	AppstoreOutline,
	AppstoreFill,
	AppstoreTwoTone,
	ArrowLeftOutline,
	ArrowRightOutline,
	ArrowUpOutline,
	BarChartOutline,
	BarsOutline,
	BellOutline,
	BellFill,
	BranchesOutline,
	CalendarOutline,
	CalendarFill,
	CalendarTwoTone,
	CheckOutline,
	CheckCircleOutline,
	CheckCircleFill,
	CheckCircleTwoTone,
	CheckSquareOutline,
	CheckSquareFill,
	CheckSquareTwoTone,
	ChromeOutline,
	ChromeFill,
	ClockCircleOutline,
	ClockCircleFill,
	ClockCircleTwoTone,
	CloseOutline,
	CloseCircleOutline,
	CloseCircleFill,
	CloseCircleTwoTone,
	CloudDownloadOutline,
	ClusterOutline,
	CommentOutline,
	CompressOutline,
	ControlOutline,
	ControlFill,
	ControlTwoTone,
	CopyOutline,
	CopyFill,
	CopyTwoTone,
	CrownOutline,
	CrownFill,
	CrownTwoTone,
	DeleteOutline,
	DeleteFill,
	DeleteTwoTone,
	DesktopOutline,
	DownOutline,
	DownloadOutline,
	EditOutline,
	EditFill,
	EditTwoTone,
	EnterOutline,
	ExclamationCircleOutline,
	ExclamationCircleFill,
	ExclamationCircleTwoTone,
	ExpandAltOutline,
	ExportOutline,
	EyeOutline,
	EyeFill,
	EyeTwoTone,
	EyeInvisibleOutline,
	EyeInvisibleFill,
	EyeInvisibleTwoTone,
	FileExcelOutline,
	FileExcelFill,
	FileExcelTwoTone,
	FileImageOutline,
	FileImageFill,
	FileImageTwoTone,
	FilePdfOutline,
	FilePdfFill,
	FilePdfTwoTone,
	FileSearchOutline,
	FileTextOutline,
	FileTextFill,
	FileTextTwoTone,
	FilterOutline,
	FilterFill,
	FilterTwoTone,
	FolderOutline,
	FolderFill,
	FolderTwoTone,
	FolderOpenOutline,
	FolderOpenFill,
	FolderOpenTwoTone,
	FolderViewOutline,
	FormOutline,
	FullscreenOutline,
	FullscreenExitOutline,
	FundViewOutline,
	GlobalOutline,
	HistoryOutline,
	HolderOutline,
	IdcardOutline,
	IdcardFill,
	IdcardTwoTone,
	ImportOutline,
	InboxOutline,
	InfoCircleOutline,
	InfoCircleFill,
	InfoCircleTwoTone,
	KeyOutline,
	LeftOutline,
	LineChartOutline,
	LinkOutline,
	LoadingOutline,
	LockOutline,
	LockFill,
	LockTwoTone,
	LogoutOutline,
	MailOutline,
	MailFill,
	MailTwoTone,
	MenuOutline,
	MergeCellsOutline,
	MessageOutline,
	MessageFill,
	MessageTwoTone,
	MobileOutline,
	MobileFill,
	MobileTwoTone,
	PauseCircleOutline,
	PauseCircleFill,
	PauseCircleTwoTone,
	PhoneOutline,
	PhoneFill,
	PhoneTwoTone,
	PieChartOutline,
	PieChartFill,
	PieChartTwoTone,
	PlusOutline,
	PlusCircleOutline,
	PlusCircleFill,
	PlusCircleTwoTone,
	PlusSquareOutline,
	PlusSquareFill,
	PlusSquareTwoTone,
	ProfileOutline,
	ProfileFill,
	ProfileTwoTone,
	QrcodeOutline,
	QuestionCircleOutline,
	QuestionCircleFill,
	QuestionCircleTwoTone,
	RadarChartOutline,
	RedoOutline,
	ReloadOutline,
	RightOutline,
	RobotOutline,
	RobotFill,
	RollbackOutline,
	SafetyOutline,
	SafetyCertificateOutline,
	SafetyCertificateFill,
	SafetyCertificateTwoTone,
	SaveOutline,
	SaveFill,
	SaveTwoTone,
	SearchOutline,
	SecurityScanOutline,
	SecurityScanFill,
	SecurityScanTwoTone,
	SendOutline,
	SettingOutline,
	SettingFill,
	SettingTwoTone,
	ShareAltOutline,
	ShopOutline,
	ShopFill,
	ShopTwoTone,
	SnippetsOutline,
	SnippetsFill,
	SnippetsTwoTone,
	SolutionOutline,
	SwapOutline,
	SyncOutline,
	TagOutline,
	TagFill,
	TagTwoTone,
	TeamOutline,
	ThunderboltOutline,
	ThunderboltFill,
	ThunderboltTwoTone,
	UnlockOutline,
	UnlockFill,
	UnlockTwoTone,
	UnorderedListOutline,
	UpOutline,
	UploadOutline,
	UserOutline,
	UserAddOutline,
	VerticalLeftOutline,
	VerticalRightOutline,
	WarningOutline,
	WarningFill,
	WarningTwoTone,
} from "@ant-design/icons-angular/icons";

export const APP_ICONS: IconDefinition[] = [
	AndroidOutline,
	AndroidFill,
	ApartmentOutline,
	AppleOutline,
	AppleFill,
	AppstoreOutline,
	AppstoreFill,
	AppstoreTwoTone,
	ArrowLeftOutline,
	ArrowRightOutline,
	ArrowUpOutline,
	BarChartOutline,
	BarsOutline,
	BellOutline,
	BellFill,
	BranchesOutline,
	CalendarOutline,
	CalendarFill,
	CalendarTwoTone,
	CheckOutline,
	CheckCircleOutline,
	CheckCircleFill,
	CheckCircleTwoTone,
	CheckSquareOutline,
	CheckSquareFill,
	CheckSquareTwoTone,
	ChromeOutline,
	ChromeFill,
	ClockCircleOutline,
	ClockCircleFill,
	ClockCircleTwoTone,
	CloseOutline,
	CloseCircleOutline,
	CloseCircleFill,
	CloseCircleTwoTone,
	CloudDownloadOutline,
	ClusterOutline,
	CommentOutline,
	CompressOutline,
	ControlOutline,
	ControlFill,
	ControlTwoTone,
	CopyOutline,
	CopyFill,
	CopyTwoTone,
	CrownOutline,
	CrownFill,
	CrownTwoTone,
	DeleteOutline,
	DeleteFill,
	DeleteTwoTone,
	DesktopOutline,
	DownOutline,
	DownloadOutline,
	EditOutline,
	EditFill,
	EditTwoTone,
	EnterOutline,
	ExclamationCircleOutline,
	ExclamationCircleFill,
	ExclamationCircleTwoTone,
	ExpandAltOutline,
	ExportOutline,
	EyeOutline,
	EyeFill,
	EyeTwoTone,
	EyeInvisibleOutline,
	EyeInvisibleFill,
	EyeInvisibleTwoTone,
	FileExcelOutline,
	FileExcelFill,
	FileExcelTwoTone,
	FileImageOutline,
	FileImageFill,
	FileImageTwoTone,
	FilePdfOutline,
	FilePdfFill,
	FilePdfTwoTone,
	FileSearchOutline,
	FileTextOutline,
	FileTextFill,
	FileTextTwoTone,
	FilterOutline,
	FilterFill,
	FilterTwoTone,
	FolderOutline,
	FolderFill,
	FolderTwoTone,
	FolderOpenOutline,
	FolderOpenFill,
	FolderOpenTwoTone,
	FolderViewOutline,
	FormOutline,
	FullscreenOutline,
	FullscreenExitOutline,
	FundViewOutline,
	GlobalOutline,
	HistoryOutline,
	HolderOutline,
	IdcardOutline,
	IdcardFill,
	IdcardTwoTone,
	ImportOutline,
	InboxOutline,
	InfoCircleOutline,
	InfoCircleFill,
	InfoCircleTwoTone,
	KeyOutline,
	LeftOutline,
	LineChartOutline,
	LinkOutline,
	LoadingOutline,
	LockOutline,
	LockFill,
	LockTwoTone,
	LogoutOutline,
	MailOutline,
	MailFill,
	MailTwoTone,
	MenuOutline,
	MergeCellsOutline,
	MessageOutline,
	MessageFill,
	MessageTwoTone,
	MobileOutline,
	MobileFill,
	MobileTwoTone,
	PauseCircleOutline,
	PauseCircleFill,
	PauseCircleTwoTone,
	PhoneOutline,
	PhoneFill,
	PhoneTwoTone,
	PieChartOutline,
	PieChartFill,
	PieChartTwoTone,
	PlusOutline,
	PlusCircleOutline,
	PlusCircleFill,
	PlusCircleTwoTone,
	PlusSquareOutline,
	PlusSquareFill,
	PlusSquareTwoTone,
	ProfileOutline,
	ProfileFill,
	ProfileTwoTone,
	QrcodeOutline,
	QuestionCircleOutline,
	QuestionCircleFill,
	QuestionCircleTwoTone,
	RadarChartOutline,
	RedoOutline,
	ReloadOutline,
	RightOutline,
	RobotOutline,
	RobotFill,
	RollbackOutline,
	SafetyOutline,
	SafetyCertificateOutline,
	SafetyCertificateFill,
	SafetyCertificateTwoTone,
	SaveOutline,
	SaveFill,
	SaveTwoTone,
	SearchOutline,
	SecurityScanOutline,
	SecurityScanFill,
	SecurityScanTwoTone,
	SendOutline,
	SettingOutline,
	SettingFill,
	SettingTwoTone,
	ShareAltOutline,
	ShopOutline,
	ShopFill,
	ShopTwoTone,
	SnippetsOutline,
	SnippetsFill,
	SnippetsTwoTone,
	SolutionOutline,
	SwapOutline,
	SyncOutline,
	TagOutline,
	TagFill,
	TagTwoTone,
	TeamOutline,
	ThunderboltOutline,
	ThunderboltFill,
	ThunderboltTwoTone,
	UnlockOutline,
	UnlockFill,
	UnlockTwoTone,
	UnorderedListOutline,
	UpOutline,
	UploadOutline,
	UserOutline,
	UserAddOutline,
	VerticalLeftOutline,
	VerticalRightOutline,
	WarningOutline,
	WarningFill,
	WarningTwoTone,
];
